import {
  PaymentSettings,
  PrinterReceiptSettings,
  ServiceChargeSettings,
  TipSettings,
  DigitalReceiptSettings,
  ZReportFields,
  IOrderTimerSettings,
  IMenuModeSettings,
  ThirdPartyPricingSettings,
  StickyPrinterReceiptSettings,
  MenuModeType,
  BreaksSetting,
} from '../types/restaurant-settings/generalSettings.types';

// Note: Using simplified structure to match actual database usage
// The database accepts this simplified format even though the type expects pos/mpos/kiosk
export const DEFAULT_PAYMENT_SETTINGS = {
  supportCard: true,
  supportCash: true,
} as unknown as PaymentSettings;

export const DEFAULT_PRINTER_RECEIPT_SETTINGS: PrinterReceiptSettings = {
  customMessage: '',
  itemModifiers: [
    {
      key: 'Print all modifiers',
      value: true,
    },
    {
      key: 'Print only those modifiers which cost extra',
      value: false,
    },
  ],
  showPaymentQR: true,
  showFeedbackQR: true,
  showCustomMessage: false,
  showItemModifiers: true,
  printCustomersCopy: true,
  printMerchantsCopy: true,
};

export const DEFAULT_SERVICE_CHARGE_SETTINGS: ServiceChargeSettings = {};

export const DEFAULT_TIP_SETTINGS: TipSettings = {
  suggestedTips: [
    { order: 0, value: 18, isDefault: false },
    { order: 1, value: 20, isDefault: true },
    { order: 2, value: 22, isDefault: false },
  ],
  areTipsEnabled: true,
};

export const DEFAULT_DIGITAL_RECEIPT_SETTINGS: DigitalReceiptSettings = {
  twitterLink: '',
  facebookLink: '',
  enableTwitter: true,
  instagramLink: '',
  enableFacebook: true,
  enableInstagram: true,
  showItemModifiers: true,
  showFeedbackSection: true,
  showItemModifierOptions: {
    showAllModifiers: true,
    showModifiersWithExtraCost: true,
  },
};

export const DEFAULT_Z_REPORT_SETTINGS: ZReportFields = {
  totalVoids: {
    voidAmount: true,
    voidPercent: true,
    voidItemCount: true,
    voidOrderCount: true,
  },
  serverTipsPaid: {
    totalCashPayments: true,
  },
  merchantDeposit: {
    merchantDeposit: false,
  },
  houseDrawerDeposit: {
    actualCash: true,
    expectedCash: true,
    startingValue: true,
    houseDrawerShort: true,
  },
  salesAndTaxSummary: {
    tax: true,
    gratuity: true,
    surcharges: true,
    totalNetSales: true,
    creditCardTips: true,
  },
  tipsHeldForPayroll: {
    tipsToBePaidOnPayroll: true,
  },
  paymentDetailsTaxExclusive: {
    card: true,
    cash: true,
    tender: true,
    giftCard: true,
    totalPayments: true,
  },
  paymentDetailsTaxInclusive: {
    card: true,
    cash: true,
    tender: true,
    giftCard: true,
    totalPayments: true,
  },
};

export const DEFAULT_ORDER_TIMER_SETTINGS: IOrderTimerSettings = {
  onHoldTimerInMinute: 5,
  orderDelayedTimerInMinute: 15,
  orderDelayedAgainTimerInMinute: 25,
};

export const DEFAULT_MENU_MODE: IMenuModeSettings = {
  table_serve_menu_mode: MenuModeType.HIERARCHICAL,
  quick_serve_menu_mode: MenuModeType.ONE_VIEW,
};

export const DEFAULT_THIRD_PARTY_PRICING: ThirdPartyPricingSettings = {};

export const DEFAULT_STICKY_PRINTER_RECEIPT_SETTINGS: StickyPrinterReceiptSettings = {};

export const DEFAULT_SHOW_FEEDBACK_SCREEN = true;

export const DEFAULT_IS_MODIFIER_SCREEN_FORCED = false;

export const DEFAULT_IS_AUTO_PRINT_PAYMENT_ENABLED = true;

export const DEFAULT_IS_SINGLE_MODIFIER_VIEW_ENABLED = false;

export const DEFAULT_ORDER_DELAY = 0;

export const DEFAULT_AVG_PREP_TIME = 20;

export const DEFAULT_BREAKS_SETTING = BreaksSetting.NO_BREAKS;

export const DEFAULT_CONFIGURABLE_CATEGORY = true;

export const DEFAULT_DINE_IN = false;

export const DEFAULT_TAKE_OUT = true;

export const DEFAULT_SHOW_MENU_NAME = false;

export const DEFAULT_IS_KIOSK_NEW_LOGIN_FLOW = false;

export const DEFAULT_SHOW_ESTIMATED_WAIT_TIME = true;

export const DEFAULT_SCREEN_TIMEOUT_TIMER = '00:00:55';

export const DEFAULT_SPECIAL_REQUEST = true;
